import { UPDATE_MEETING_NOTES } from '../MeetingMutations'
import { client } from '../../..'
import { UpdateMeetingNotesMutation, UpdateMeetingNotesMutationVariables, Meeting } from '../../../types'
import { MEETING_WITH_CAREER_PATH_EVALUATION } from '../MeetingQueries'

export const updateMeetingNotes = async (meetingId: Meeting['id'], notes: string): Promise<void> => {
  await client.mutate<UpdateMeetingNotesMutation, UpdateMeetingNotesMutationVariables>({
    mutation: UPDATE_MEETING_NOTES,
    variables: {
      meetingId,
      notes,
    },
    refetchQueries: [
      {
        query: MEETING_WITH_CAREER_PATH_EVALUATION,
        variables: {
          meetingId,
        },
      },
    ],
  })
}
